import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite:idHotsiteLocalStorage > 0 ? idHotsiteLocalStorage :  4,
  Loja: "Pacific Currency",
  UserStorage: "+Ldk3/RowkShd+nUhs0Z3w==",
  UserToken: "wYDujXAMXUqL3eXBkLO3aQ==",
  UrlApi: "https://prd-ecommerce-und-api.primecase.com.br/api",
  UrlLoja:"https://pacificcurrency.com/",
  UrlServiceHost: "https://dev2-pri-sgc-api.primecase.com.br/",

  OrgId: "",
  ProviderMerchantId: ""
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#2391D5",
      light: "#ffc800",
      //lighter: "#ece6f7",
      dark: darkenColor("#2391D5", 10), // Escurece em 20%
    },
    secondary: {
      main: "#000",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
